import React, {useTransition, useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {
  Button,
  Form,
  Table,
  message,
  Image,
  Drawer,
  Space,
  Popconfirm,
} from 'antd';
import type {TableColumnsType} from 'antd';

import {
  RollbackOutlined,
  EditFilled,
  DeleteFilled,
  PlusOutlined,
  CloseOutlined,
  SaveFilled,
} from '@ant-design/icons';
import {useGetMenuByShopId} from 'hooks/shop/menu/useGetMenu';
import {
  useCreateMenu,
  useUpdateMenu,
  useDeleteMenu,
  useToggleMenu,
} from 'hooks/shop/menu/useUpdateMenu';
import {useGetShopById} from 'hooks/shop/useGetShop';
import {FormMenu} from 'components/shop/FormMenu';
import {addKeyData, formatNumberToString, formatStringToNumber} from 'utils';
export const MenuShop: React.FC = () => {
  const [isPending, startTransition] = useTransition();
  const navigate = useNavigate();
  const params = useParams();
  const [form] = Form.useForm();
  const {data, isLoading, isError, isSuccess, refetch} = useGetMenuByShopId(
    params?.id || '',
  );
  const {
    mutateAsync: createMenu,
    isLoading: isLoadingCreate,
    isError: isErrorCreate,
  } = useCreateMenu();
  const {
    mutateAsync: onUpdateMenu,
    isLoading: isLoadingUpdate,
    isError: isErrorUpdate,
  } = useUpdateMenu();
  const {mutateAsync: onToggleMenu} = useToggleMenu();
  const {mutateAsync: onDeleteMenu, isError: isErrorDelete} = useDeleteMenu();
  const {data: dataShop} = useGetShopById(params?.id || '');
  const [open, setOpen] = useState(false);
  const [idMenu, setIdMenu] = useState('');
  useEffect(() => {
    if (isError) {
      message.error(`Không tìm thấy shop có id: ${params?.id}`);
      navigate('/shop', {
        state: {from: `/shop/menu/${params?.id}`},
      });
    }
    if(isSuccess){
      document.title = `Thông tin menu của shop ${dataShop?.name}`;
    }
    setIdMenu('');
  }, [isSuccess,dataShop?.name, isError, navigate, params?.id]);
  const formattedMenu = (arr = []) => {
    const newArray = arr.map((item: any) => {
      const {first, last} = item;
      return {[first]: formatStringToNumber(last)};
    });
    return newArray;
  };
  const formattedApiToMenu = (arr = []) => {
    const newArray = arr.map((item: any) => {
      const key = Object.keys(item)[0];
      return {first: key, last: formatNumberToString(item[key])};
    });
    return newArray;
  };

  const handleConfirm = async (id: string) => {
    try {
      await onDeleteMenu(id);
      message.success('Xóa thành công');
      await refetch();
    } catch (error) {
      if (isErrorDelete) {
        message.error('Xoá không thành công');
      }
    }
  };
  const handleToggle = async (id: string) => {
    await onToggleMenu(id);
    await refetch();
  };
  const columns: TableColumnsType = [
    {title: 'Tên món ăn', dataIndex: 'name', key: 'name'},
    {
      title: 'Hình ảnh',
      dataIndex: 'image',
      key: 'image',
      render: data => {
        return (
          <Image
            width={180}
            height={120}
            src={data}
            fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
          />
        );
      },
    },
    {
      title: 'Giá',
      dataIndex: 'price',
      key: 'price',
      render: data => {
        return (
          <div>
            <p>{formatNumberToString(data)}</p>
          </div>
        );
      },
    },
    {title: 'Loại món ăn', dataIndex: 'type', key: 'type'},
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      render: (data, record: any) => {
        return (
          <Popconfirm
            title={`Chú ý`}
            description={`Bạn có chắc muốn ${
              data ? 'Ẩn' : 'Hiện'
            }`}
            okText="Yes"
            cancelText="No"
            onConfirm={() => handleToggle(record?._id)}>
            {data ? (
              <Button type="primary">Hiện</Button>
            ) : (
              <Button className="!border-white bg-[#ed250e] hover:!bg-[#f25c4b] !text-white !font-medium">
                Ẩn
              </Button>
            )}
          </Popconfirm>
        );
      },
    },
    {
      title: '',
      dataIndex: '',
      key: 'action',
      align: 'center',
      render: (text, record: any) => {
        return (
          <div className="flex gap-4 px-0">
            <Button
              icon={<EditFilled />}
              className="!border-white	 bg-[#eca52b] hover:!bg-[#edb555] !text-white !font-medium"
              onClick={() => {
                startTransition(() => {
                  setIdMenu(record._id);
                  const sizes = formattedApiToMenu(record.sizes);
                  const ingredients = formattedApiToMenu(record.ingredients);
                  form.setFieldsValue({
                    ...record,
                    price: formatNumberToString(record.price),
                    sizes,
                    ingredients,
                  });
                  setOpen(true);
                });
              }}>
              Chỉnh sửa
            </Button>
            <Popconfirm
              title={`Xoá món ăn`}
              description={`Bạn có chắc muốn xoá ${record.name}`}
              okText="Yes"
              cancelText="No"
              onConfirm={() => handleConfirm(record?._id)}>
              <Button
                icon={<DeleteFilled />}
                className="!border-white bg-[#ed250e] hover:!bg-[#f25c4b] !text-white !font-medium">
                Xoá
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];
  const onClose = () => {
    form.resetFields();
    setIdMenu('');
    setOpen(false);
  };

  const handleSave = async () => {
    try {
      const values = await form.getFieldsValue();
      const data = {
        ...values,
        sizes: formattedMenu(values.sizes),
        ingredients: formattedMenu(values.ingredients),
        price: formatStringToNumber(values.price),
        shopId: params.id,
      };
  
      if (idMenu) {
        await onUpdateMenu({
          id: idMenu,
          body: data,
        });
      } else {
        await createMenu(data);
      }
      onClose();
      refetch();
    } catch (error) {
      if (isErrorCreate) {
        message.error('Tạo không thành công');
      }
      if (isErrorUpdate) {
        message.error('Cập nhật không thành công');
      }
    }
  };
  return (
    <div className="container mx-auto">
      <div className="flex-col gap-4">
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-bold">{ `Thông tin menu của shop ${dataShop?.name}`}</h2>
          <div className="flex gap-3 items-center">
            <Button
              icon={<RollbackOutlined />}
              onClick={() =>
                {
                  navigate(-1);
                }
                // navigate('/shop', {
                //   replace: true,
                //   state: {from: '/shop/menu'},
                // })
              }>
              Trở về
            </Button>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                form.resetFields();
                setOpen(true);
              }}>
              Thêm món ăn
            </Button>
          </div>
        </div>
        <Table
          loading={isLoading}
          dataSource={addKeyData(data)}
          columns={columns}
        />
        <Drawer
          title={idMenu ? 'Chỉnh sửa món ăn' : 'Thêm món ăn'}
          width={720}
          onClose={onClose}
          open={open}
          styles={{
            body: {
              paddingBottom: 80,
            },
          }}
          extra={
            <Space>
              <Button icon={<CloseOutlined />} onClick={onClose}>
                Huỷ
              </Button>
              {idMenu ? (
                <Button
                  icon={<EditFilled />}
                  className="!border-white	 bg-[#eca52b] hover:!bg-[#edb555] !text-white !font-medium"
                  onClick={() => {
                    startTransition(() => {
                      handleSave();
                    });
                  }}
                  loading={isLoadingUpdate}
                  type="primary">
                  Chỉnh sửa
                </Button>
              ) : (
                <Button
                  icon={<SaveFilled />}
                  onClick={() => {
                    startTransition(() => {
                      handleSave();
                    });
                  }}
                  loading={isLoadingCreate}
                  type="primary">
                  Thêm
                </Button>
              )}
            </Space>
          }>
          <FormMenu form={form} dataShop={dataShop} />
        </Drawer>
      </div>
    </div>
  );
};
